/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import { BuyersGuideBanner } from './BuyersGuideBanner';
import styles from './styles.module.scss';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';

type Props = {
  children: React.ReactNode;
  openBuyersGuide: () => void;
};
const labelMap = {
  labelThisPart: 'label_thisPart',
  labelFitsTheseVehicles: 'label_fitsTheseVehicles',
};

export function BuyersGuideWrapper(props: Props) {
  const { openBuyersGuide } = props;
  const labels = useLabels(labelMap);
  const isPdpLowerV2Enabled = useForteDecisionFlagWithTrueDefault('pdpRedesignEnabled');

  return (
    <>
      <div
        data-testid="bannerContainer"
        className={isPdpLowerV2Enabled ? styles.bannerContainerV2 : styles.bannerContainer}
      >
        <BuyersGuideBanner
          openBuyersGuide={openBuyersGuide}
          lblFitmentOne={labels.labelThisPart}
          lblFitmentTwo={labels.labelFitsTheseVehicles}
        />
      </div>
      {props.children}
    </>
  );
}
